
import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		document.querySelectorAll(".content-columns-with-cards .splide").forEach(el => {
		const label = el.dataset.sliderLabel;
		const describedById = el.dataset.sliderDescribedby;
		const applyAriaAttrs = () => {
			if (label) el.setAttribute('aria-label', label);
			if (describedById) el.setAttribute('aria-describedby', describedById);
		};
		const removeAriaAttrs = () => {
			el.removeAttribute('aria-label');
			el.removeAttribute('aria-describedby');
		};
		applyAriaAttrs();
		const splide = new Splide(el, {
			type: 'slide',
			arrows: true,
			pagination: true,
			perPage: 1,
			gap: '2rem',
			mediaQuery: 'min',
			breakpoints: {
			1024: { destroy: true },
			},
			i18n: { slide: 'Column' },
		});
		splide.on('destroy', removeAriaAttrs);
		splide.on('mounted', applyAriaAttrs);
		splide.mount();
		});
	})
  .catch(console.error);

// Promise.all([import('gsap'), import('gsap/ScrollTrigger')])
// 	.then(([{ gsap }, { ScrollTrigger }]) => {
// 		gsap.registerPlugin(ScrollTrigger);
// 		document.querySelectorAll('.content-columns-with-cards').forEach(wrapper => {
// 		const bgImg = wrapper.querySelector('.img-anim');
// 		const imgWrapper = wrapper.querySelector('.img-wrapper-anim');
// 		const header = wrapper.querySelector('.header-anim');
// 		const content = wrapper.querySelectorAll('.content-anim');
// 		const container = wrapper.querySelector('.sorbet-align-container');

// 		if(!bgImg || !imgWrapper || !content.length) return;

// 		let getOffset;

// 		if(header) {
// 			getOffset = () => {
// 				const gap = parseFloat(getComputedStyle(container).rowGap) || 0;
// 				return header.offsetHeight + gap;
// 			};
// 		} else {
// 			getOffset = () => 0;
// 		}
// 		content.forEach(el => gsap.set(el, { opacity: 0, y: 20 }));
// 		gsap.set(bgImg, { scale: .25, y: '8%', borderRadius: '80% 80% 0 0' });
// 		const tl = gsap.timeline({
// 			scrollTrigger: {
// 			trigger: imgWrapper,
// 			start: '8% bottom',
// 			end: 'bottom bottom',
// 			scrub: .5,
// 			invalidateOnRefresh: true,
// 			},
// 		});
// 		tl.to(bgImg, { scale: 1, y: '0%', duration: 0.45 })
// 			.to(bgImg, { borderRadius: '0', duration: 0.6 }, '<')
// 			.to(imgWrapper, { y: () => -getOffset() }, 0);
// 		if(header) { new ResizeObserver(() => ScrollTrigger.refresh()).observe(header); }
// 		tl.to(content, {
// 			opacity: 1,
// 			y: 0,
// 			stagger: 0.1,
// 			duration: 0.2});
// 		});
// 	})
// 	.catch(console.error);